import { Alert, Icon } from "@app/ui";
import { useAuth } from "../auth/AuthContext.js";
import { useT } from "../i18n.js";

/**
 * Shown in the app shell for the shared read-only demo login. Every mutating
 * request is rejected server-side (see the demo gate in the API authenticate
 * plugin); this banner sets the expectation up front. Renders nothing for
 * normal accounts.
 */
export function DemoBanner() {
  const t = useT();
  const { user } = useAuth();
  if (!user?.demo) return null;
  return (
    <Alert type="info" className="app-banner" icon={false}>
      <div className="app-banner-row">
        <span className="app-banner-msg">
          <Icon name="info" size={14} className="text-[var(--az-info)]" />
          {t("demo.banner")}
        </span>
      </div>
    </Alert>
  );
}
